<template>
  <div class="picDialog">
    <el-dialog :visible.sync="dialogVisible" :width="dialogWidth" :before-close="handleClose"
      :modal-append-to-body='false'>

      <el-carousel :interval="5000" arrow="always" indicator-position="none" :initial-index="index"
        :height="clientHeight" @change="_carouselChange">
        <el-carousel-item v-for="(item, index) in carouselDate" :key="index">
          <div>
            <!-- <el-image :src="item.picUrl"></el-image> -->
            <img :src="item.picUrl" :id="'pic' + index" class="item-img" />
            <h3>{{ item.title }}</h3>
          </div>
        </el-carousel-item>
        <!-- <img :src="carouselImg[0].picUrl" alt="" class="carouselImg" /> -->
      </el-carousel>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      carouselDate: [],
      carouselImg: [{ picUrl: '' }],
      dialogWidth: '50%',
      index: 0,
      carouselHeight: '',
      clientHeight: (document.documentElement.clientHeight - 280) + 'px'
    }
  },
  methods: {
    open(data, index) {
      for (let i of data) {
        if (i.imgUrl) {
          i.picUrl = i.imgUrl;
        }
      }
      this.carouselDate = data;
      this.carouselImg = data;
      this.dialogVisible = true;
      this.index = index || 0;
      setTimeout(()=>{
        this._carouselChange(index)
      },300)
    },
    handleClose() {
      this.dialogVisible = false;
      this.carouselDate = [];
    },
    _carouselChange(event) {
      const img = document.getElementById('pic' + event)
      if (!img) return
      let width = img.naturalWidth
      let height = img.naturalHeight
      if (width > height) {
        if (width > 600) width = 600
        height = parseInt(img.naturalHeight * width / img.naturalWidth) + 30
      } else {
        if (height > 600) height = 600
        width = parseInt(img.naturalWidth * height / img.naturalHeight)
      }
      this.clientHeight = height + 'px'
      this.dialogWidth = width + 'px'
    }
  },
  created() {
  },
  mounted() {
    let screenWidth = document.documentElement.clientWidth;
    if (screenWidth <= 768) {
      this.dialogWidth = '80%';
    } else {
      this.dialogWidth = '50%';
    }
  },
}
</script>
<style lang="less" scoped>
.picDialog {
  /deep/.el-dialog {
    background: none;
    box-shadow: none;
  }

  /deep/.el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 30px;
  }

  /deep/.el-carousel--horizontal {
    overflow-y: hidden;
  }

  .item-img {
    // max-width: 500px;
    // max-height: 500px;
    width: 100%;
    height: 100%;
  }

  /deep/.el-carousel__item {
    div {
      text-align: center;

      .el-image {
        // height: 80%;
        max-width: 500px;
        max-height: 500px;
      }

      h3 {
        color: #475669;
        font-size: 16px;
        margin-top: -5px;
        background-color: #fff;
        // padding: 15px;
        font-weight: normal;
        height: 40px;
        line-height: 40px;
      }
    }
  }

  .el-image__error,
  .el-image__inner,
  .el-image__placeholder {
    height: auto;
  }

  //  /deep/ .el-carousel__container{
  //     height: auto!important;
  //   }
  // .carouselImg{
  //   opacity: 0;
  //   width:100%;
  // }
  // @media (min-width: 768px) {
  //   .carouselImg{
  //       height:500px!important;
  //       min-height:500px!important;
  //   }
  // }

}
</style>



// WEBPACK FOOTER //
// src/components/common/components/picDialog.vue